import { Component } from '@angular/core';
import { AbstractSectionComponent } from '../../shared/components/abstract-section/abstract-section.component';
import * as moment from 'moment';
import { validateFormField } from '../../../../shared/validators';

@Component({
  selector: 'app-results-section',
  templateUrl: './results-section.component.html',
  styleUrls: ['../../shared/components/abstract-section/abstract-section.component.scss', './results-section.component.scss']
})
export class ResultsSectionComponent extends AbstractSectionComponent {

  public override async validate(): Promise<boolean> {
    validateFormField(this.note);
    return this.note.valid;
  }

  public override async save(): Promise<boolean | null> {

    if (this.note.value && this.note.value !== '') {
      this.data.notes = [...(this.data.notes || []), {
        author: this.activeUserService.user!,
        content: this.note.value,
      }];
    }

    return super.save();
  }

  public saveNotes(runSave: boolean) {
    if (runSave) {
      this.saveAll().subscribe();
    }
  }

}
